import React from "react";
import { TouchableOpacity, StyleSheet } from "react-native";
import Svg, { Path } from "react-native-svg";

const SnoozeIcon = ({ onPress, style }) => {
  return (
    <TouchableOpacity
      onPress={(e) => onPress(e)}
      style={[styles.closeButton, style]}
    >
      <Svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2 11.5667C10.8627 11.5667 11.4 11.0295 11.4 10.3667C11.4 9.70401 10.8627 9.16675 10.2 9.16675C9.53726 9.16675 9 9.70401 9 10.3667C9 11.0295 9.53726 11.5667 10.2 11.5667ZM6.2 11.5668C6.86274 11.5668 7.4 11.0296 7.4 10.3668C7.4 9.70409 6.86274 9.16683 6.2 9.16683C5.53726 9.16683 5 9.70409 5 10.3668C5 11.0296 5.53726 11.5668 6.2 11.5668ZM15 10.3667C15 11.0295 14.4628 11.5667 13.8 11.5667C13.1373 11.5667 12.6 11.0295 12.6 10.3667C12.6 9.70401 13.1373 9.16675 13.8 9.16675C14.4628 9.16675 15 9.70401 15 10.3667Z"
          fill="#8B92A1"
        />
      </Svg>
    </TouchableOpacity>
  );
};

export default SnoozeIcon;

const styles = StyleSheet.create({
  closeButton: {
    position: "absolute",
    right: 6,
    top: 6,
    zIndex: 3,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
